import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import isNewYearTime from "../../utils/isNewYear";
import { sendNavigationMetric } from "../../utils/sendMetric";

// eslint-disable-next-line no-unused-vars
import logo from "./images/Logo.svg";
// eslint-disable-next-line no-unused-vars
import smallLogo from "./images/SmallLogo.svg";
import newYearImg from "./images/atiNewYear.png";
import newYearSmallImg from "./images/atiNewYearSmall.png";

import styles from "./Logo.scss";

const cx = classnames.bind(styles);

/**
 * Компонент логотипа компании
 *
 * Важно!!!
 * При любом обновлении изображения логотипа нужно обновить файлы Logo.svg и SmallLogo.svg в папке images.
 * Эти файлы используется другими компаниями для отображения нашего логотипа.
 * Здесь они лежат для своевременного обновления, так как логотип шапки всегда обязан оставаться актуальным и здесь будет проще актуализировать его.
 */

const Logo = ({ baseUrl, className }) => {
  const isPrerender = process.env.PRERENDER === "1";
  const currentBaseUrl = isPrerender ? "SSI_PATH_TO_BASE_URL" : baseUrl;

  return (
    <div className={cx("logo-section", className)}>
      <a
        href={`https://${currentBaseUrl}?utm_source=header&utm_campaign=new_header`}
        data-name="logo"
        className={cx("logo", {
          prerender: isPrerender,
        })}
        onClick={() => sendNavigationMetric("LOGO")}
      >
        <svg
          width="120"
          height="38"
          className={cx("big-logo")}
          data-name="big-logo-img"
        >
          <path
            fill="var(--glz-color-neutral-tone-5)"
            fillRule="evenodd"
            d="M8.827 2.963A3.99 3.99 0 0 0 14.81.474a18.925 18.925 0 0 1 8.416 0 3.99 3.99 0 0 0 5.986 2.489 18.908 18.908 0 0 1 5.964 6.022 3.989 3.989 0 0 0 2.43 6.005 18.87 18.87 0 0 1 0 8.02 3.989 3.989 0 0 0-2.43 6.006 18.904 18.904 0 0 1-5.966 6.021 3.99 3.99 0 0 0-5.984 2.489 18.925 18.925 0 0 1-8.416 0 3.99 3.99 0 0 0-5.986-2.489 18.909 18.909 0 0 1-5.963-6.022A3.989 3.989 0 0 0 .43 23.01a18.87 18.87 0 0 1 0-8.02A3.989 3.989 0 0 0 2.86 8.984a18.904 18.904 0 0 1 5.967-6.021Zm10.191 29.334c7.35 0 13.31-5.953 13.31-13.297 0-7.343-5.96-13.296-13.31-13.296C11.668 5.704 5.71 11.657 5.71 19c0 7.343 5.959 13.297 13.31 13.297Zm-4.088-2.654v-6.869h7.985v6.94c4.382-1.59 7.511-5.787 7.511-10.714 0-6.294-5.107-11.397-11.408-11.397-6.3 0-11.408 5.103-11.408 11.397 0 4.855 3.039 9 7.32 10.643Zm7.985-12.817a3.99 3.99 0 0 0-3.993-3.99 3.99 3.99 0 0 0-3.992 3.99 3.99 3.99 0 0 0 3.992 3.988 3.99 3.99 0 0 0 3.993-3.988ZM82.372 8.186a2.47 2.47 0 0 1-2.472 2.47 2.47 2.47 0 1 1 2.472-2.47Zm-4.944 18.039V11.869h4.944v14.356h-4.944Zm13.76-4.695c.038 3.506 2.721 5.173 6.333 5.173 3.938 0 6.346-1.512 6.346-4.953 0-1.763-.74-2.995-2.219-3.695-1.01-.477-2.139-.669-3.244-.857a60.247 60.247 0 0 1-.663-.115l-.127-.029c-.593-.13-1.482-.325-1.482-1.06 0-.329.121-.588.363-.778.547-.43 1.538-.39 2.064.051.268.225.402.562.402 1.012h4.634c-.026-1.461-.593-2.632-1.701-3.514-1.098-.89-2.556-1.335-4.373-1.335-2.888 0-6.139 1.428-6.139 4.732 0 .824.176 1.657.623 2.36.389.565.965.997 1.57 1.31.928.463 1.968.667 2.985.83.84.137 1.458.297 1.856.479.7.297.827 1.192.195 1.647-.62.439-1.616.377-2.193-.104-.312-.268-.468-.653-.468-1.154h-4.763Zm14.666-1.466c0 4.052 3.169 6.626 7.086 6.626 3.918 0 7.06-2.58 7.06-6.626v-8.181h-4.945v8.164c0 1.114-.722 2.208-2.115 2.208-1.392 0-2.142-1.087-2.142-2.208v-8.164h-4.944v8.181Zm-16.408 4.15a2.49 2.49 0 0 1-2.492 2.49 2.49 2.49 0 0 1-2.492-2.49 2.49 2.49 0 0 1 2.492-2.49 2.49 2.49 0 0 1 2.492 2.49ZM71.567 11.869V7.286h-1.78l-5.833 6.35v2.09h2.67v4.669c-.074 1.853.23 3.492 1.53 4.648 1.243 1.104 2.363 1.19 4.865 1.19h2.104V21.9h-2.121c-.775-.01-1.45-.753-1.434-1.51v-4.664h3.473V11.87h-3.474Zm-13.74 13.326a7.226 7.226 0 0 1-4.401 1.495c-4.09 0-7.404-3.417-7.404-7.633 0-4.215 3.315-7.632 7.404-7.632 1.68 0 3.23.577 4.473 1.55l.41-1.1h3.814v14.342h-3.928l-.368-1.022Zm-.383-6.144c0 1.82-1.441 3.294-3.22 3.294-1.778 0-3.22-1.475-3.22-3.294 0-1.82 1.442-3.294 3.22-3.294 1.779 0 3.22 1.475 3.22 3.294Z"
            clipRule="evenodd"
          />
        </svg>
        {isNewYearTime && (
          <img
            className={cx("ati-newYear")}
            src={newYearImg}
            alt="atiNewYear"
          />
        )}
        <svg
          width="38"
          height="38"
          className={cx("small-logo")}
          data-name="small-logo-img"
        >
          <path
            fill="var(--glz-color-neutral-tone-5)"
            fillRule="evenodd"
            d="M8.825 2.975a3.98 3.98 0 0 0 3.624.287 3.98 3.98 0 0 0 2.35-2.774A18.876 18.876 0 0 1 23.2.487a3.98 3.98 0 0 0 2.35 2.775 3.981 3.981 0 0 0 3.626-.288 18.887 18.887 0 0 1 5.953 6.02 3.98 3.98 0 0 0-.324 3.62 3.981 3.981 0 0 0 2.75 2.379c.561 2.59.586 5.319 0 8.014a3.981 3.981 0 0 0-2.75 2.379 3.981 3.981 0 0 0 .326 3.622 18.882 18.882 0 0 1-5.957 6.017 3.98 3.98 0 0 0-3.624-.287 3.98 3.98 0 0 0-2.35 2.774c-2.71.618-5.577.646-8.402.001a3.98 3.98 0 0 0-2.35-2.775 3.98 3.98 0 0 0-3.626.288 18.884 18.884 0 0 1-5.954-6.02 3.98 3.98 0 0 0 .325-3.62 3.981 3.981 0 0 0-2.75-2.38 18.874 18.874 0 0 1 0-8.013 3.98 3.98 0 0 0 2.75-2.38 3.98 3.98 0 0 0-.326-3.621 18.88 18.88 0 0 1 5.957-6.017ZM19 32.287c7.338 0 13.287-5.949 13.287-13.287 0-7.338-5.949-13.287-13.287-13.287-7.338 0-13.287 5.949-13.287 13.287 0 7.338 5.949 13.287 13.287 13.287Zm-4.082-2.652v-6.864h7.972v6.936c4.374-1.59 7.499-5.784 7.499-10.707 0-6.29-5.1-11.389-11.389-11.389-6.29 0-11.389 5.1-11.389 11.389 0 4.851 3.034 8.994 7.307 10.635Zm7.972-12.808a3.986 3.986 0 1 0-7.972 0 3.986 3.986 0 0 0 7.972 0Z"
            clipRule="evenodd"
          />
        </svg>
        {isNewYearTime && (
          <img
            className={cx("ati-newYear-small")}
            src={newYearSmallImg}
            alt="atiNewYear"
          />
        )}
      </a>
    </div>
  );
};

Logo.propTypes = {
  baseUrl: PropTypes.string,
  className: PropTypes.string,
};

export default Logo;
